export default "__VITE_ASSET__DFid_CLe__"